export const isActiveThread = (threadId, activeThreadId) =>
  threadId === activeThreadId;
